import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'legalMatter/';

export function useLegalMatterFilter({
	filterRequest,
	pageSize = 25,
	sort = 'openDate',
	sortDescending = true,
	enabled = true,
	refetchOnWindowFocus = false,
	expand = 'contact',
}: {
	filterRequest: Api.ILegalMatterFilterRequest;
	pageSize?: number;
	sort?: 'openDate' | 'matterName' | 'stage' | 'status';
	sortDescending?: boolean;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	expand?: string;
}) {
	const userSession = useUserSession();

	return useInfiniteQuery<Api.IPagedCollection<Api.ILegalMatter>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ILegalMatter>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageSize, pageToken: pageParam, sort, sortDescending, expand },
					urlPath: 'LegalMatter/filter',
				}),
				'POST',
				filterRequest
			);
		},
		refetchOnWindowFocus,
		queryKey: [BASE_QUERY_KEY, filterRequest, pageSize, sort, sortDescending, expand],
		initialPageParam: '',
	});
}

export const invalidateLegalMatterFilter = ({
	filterRequest,
	sort = 'openDate',
	sortDescending = true,
	expand = 'contact',
	pageSize = 25,
}: {
	filterRequest: Api.ILegalMatterFilterRequest;
	sort?: 'openDate' | 'matterName' | 'stage' | 'status';
	sortDescending?: boolean;
	expand?: string;
	pageSize?: number;
}) => {
	reactQueryClient.invalidateQueries({
		queryKey: [BASE_QUERY_KEY, filterRequest, pageSize, sort, sortDescending, expand],
	});
};

export const invalidateAllLegalMatterFilters = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
